import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKanban = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 1.5,
			width: 13,
			height: 13,
			rx: 2,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.86963,
			y: 6.00023,
			width: 3,
			height: 2,
			rx: .5,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.86963,
			y: 10.0202,
			width: 3,
			height: 2,
			rx: .5,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9.13037,
			y: 6.00023,
			width: 3,
			height: 2,
			rx: .5,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.36963,
			y: 3.47978,
			width: 4,
			height: 1,
			rx: .5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.63037,
			y: 3.47978,
			width: 4,
			height: 1,
			rx: .5,
			fill: "currentColor"
		})
	]
});
export default SvgKanban;
